<div class="col text-center mt-3 d-flex justify-content-center" *ngIf="showLoadMoreBtn">
    <button mat-flat-button color="accent" (click)="loadMore()">
        <mat-icon>expand_circle_down</mat-icon> {{'Actions.LoadMore' | translate}}
    </button>
</div>